module.exports = __webpack_public_path__ + "img/objects.94f13012.png";